// extracted by mini-css-extract-plugin
module.exports = {"statuses":"legend_statuses__2Wn5W","statusItem":"legend_statusItem__1qOUo","status":"legend_status__3ejMH","statusColor":"legend_statusColor__OHviN"};